// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import * as pdfjs from 'pdfjs-dist'
// Vite resolves `?url` to the final bundled asset URL — the reliable way to point pdf.js at its
// worker in production (the bare `new URL(..., import.meta.url)` form can resolve wrong after build).
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

let configured = false

/** Idempotently point pdf.js at its worker. Call before any getDocument(). */
export function ensurePdfWorker() {
  if (configured) return
  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
  configured = true
}

export { pdfjs }
